module.exports = __webpack_public_path__ + "static/media/DSMThumb.d52b7279.png";